/* eslint-disable no-param-reassign */
import uniq from 'lodash.uniq';

export function arrayToIdMappedObject(arr, idKey = 'id') {
  if (!Array.isArray(arr)) {
    return {};
  }
  return arr.reduce((acc, item) => {
    // eslint-disable-next-line no-param-reassign
    acc[item[idKey]] = item;
    return acc;
  }, {});
}

export function ensureItems(responseBody) {
  return Array.isArray(responseBody && responseBody.items) ? responseBody.items : [];
}

export const immerEnsurePath = (immerState, path) => {
  let ensuredPath = immerState;
  // Make sure path exists
  path.forEach(prop => {
    if (!Object.prototype.hasOwnProperty.call(ensuredPath, prop)) {
      ensuredPath[prop] = {};
    }
    ensuredPath = ensuredPath[prop];
  });
  return ensuredPath;
};

export const immerSet = (immerState, path, value) => {
  // Let immerEnsurePath create objects for the whole path except the last entry
  // which is the prop we want to set.
  const obj = immerEnsurePath(immerState, path.slice(0, -1));
  obj[path[path.length - 1]] = value;
};

export const immerMergeObject = (immerState, path, value) => {
  const obj = immerEnsurePath(immerState, path);
  Object.entries(value).forEach(([prop, val]) => {
    obj[prop] = val;
  });
};
export const immerMergeArray = (immerState, path, value) => {
  const obj = immerEnsurePath(immerState, path.slice(0, -1));
  const lastPath = path[path.length - 1];

  // If the target is not already an array just add it.
  if (!obj[lastPath] || !obj[lastPath].length) {
    obj[lastPath] = [...value];
  } else {
    // If the target is an array we should make sure it's entries are unique after merge.
    obj[lastPath] = uniq([...obj[lastPath], ...value]);
  }
};

// Immer gives you a cloned state object that you modify
export function addManyToImmerState(state, responseBody) {
  if (!responseBody || !responseBody.items) {
    return;
  }

  if (responseBody.total) {
    state.total = responseBody.total;
  }

  if (Array.isArray(responseBody.items)) {
    responseBody.items.forEach(item => {
      if (!item.id) {
        return;
      }
      state.items[item.id] = item;
    });
  }
}

export function addOneToImmerState(state, responseBody) {
  if (!responseBody || !responseBody.id) {
    return;
  }

  immerMergeObject(state, ['items', responseBody.id], responseBody);
}
